import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgRedeem({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.975 4.61L12 4.587l.025.025A3 3 0 1117.829 6H19a3 3 0 013 3v10a3 3 0 01-3 3H5a3 3 0 01-3-3V9a3 3 0 013-3h1.17a3 3 0 115.804-1.39zM15.415 8l2.292 2.293a1 1 0 01-1.414 1.414L12.586 8h-1.172l-3.707 3.707a1 1 0 01-1.414-1.414L8.586 8H5a1 1 0 00-1 1v6h16V9a1 1 0 00-1-1h-3.586zM20 17H4v2a1 1 0 001 1h14a1 1 0 001-1v-2zM9 6a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgRedeem
